import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import {BasicSelect,  f,  MultiSelect} from 'vue-search-select'
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import Utility from './../../../utility/services/utility.service';
import Loader from './../../../shared/components/loader'
import Treeselect from '@riophae/vue-treeselect';
import CONSTANT from './../../../shared/constants/constant';
import Pagination from './../../../shared/components/pagination';

export default {
  name: 'MarkshipmentInvalidOnchildLevel',
  components: {
    //VueElementLoading,
    Treeselect,
    Paginate,
    BasicSelect,
    Utility,
    vueMultiSelect,
    Loader,
    Pagination
  },
  data: function() {
    return {
      awbnumber: '',
      commenterr:'',
      isLoading:false,
      tableData:[],
      showMPSList:false,
      selectedMPS:[],
      comments:[],
      mpsflagselectArr:[],
      isAllAddedSelected:"",
      Arr:[],
      tempArr:[],
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      showMPSInvalid:false,
      finalresult:[]
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
  },
  methods: {
    setname(id, name){
      return name+id;
    },
    check (e) {
       let obj={};
        let text = e.srcElement.id;
        let result = text.substring(11,text.length);
        if(e.srcElement.checked == true){
           obj = {
            flag: e.srcElement.checked,
            MPS: e.srcElement._value.shippingid,
            shipmentstatus:e.srcElement._value.shipmentstatus,
            index: result
          }
          this.Arr.push(obj) 
          }else{
            const itemToRemoveIndex = this.Arr.findIndex(function(item) {
              return item.flag === 'false';
            });
            if(itemToRemoveIndex === -1){
              this.Arr.splice(itemToRemoveIndex, 1);
            }
          }  
    },
    isIntegerOnly: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.updateMarkMPSInvalidOnChild();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    reset() {
      this.tableData = [];
      this.comments = [];
      this.selectedMPS = [];
      this.awbnumber = '';
      this.showMPSList=false;
      this.Arr = [];
      this.tempArr = [],
      this.finalresult= []
    },
    async getMPSList(){
      try{
        this.Arr = []
        this.tempArr = []
        this.finalresult = []
        this.$validator.validateAll("markchildinvalidform").then( async (result) => {
          if(result){
            this.tableData = [];
            this.comments = [];
            this.selectedMPS = [];
            this.isLoading=true;
            let inputPayload = {
              parentAWB: this.awbnumber,
              offset:this.offset == 0 ? "1" : this.offset.toString(),
              pageLimit:this.pageLimit.toString()
            };
            let result = await Utility.getMPSlistdetails(inputPayload);
            if(result.data.code == 200){
              this.totalCount = parseInt(result.data.data.data.TotalCount);
              result.data.data.data.Result.forEach((item, i) => {
                this.tableData.push(result.data.data.data.Result[i]);
              });
              if (this.totalCount < this.pageLimit) {
                this.totalPage = 1
              } else {
                this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
              }
              this.showMPSList=true;
              this.isLoading=false;
            }
            else {
              this.isLoading=false;
              this.$alertify.error(result.data.message)
            }

          }
        }).catch((err) => {
          console.error(err);
          return false;
        });
      }
      catch(err){
        this.$alert(err,"","error");
      }
    },
    async updateMarkMPSInvalidOnChild() {
      try {
        let inputPayload ={}
        this.tempArr = []
        this.tempArr = this.Arr.map((e,index) => {
          return {
            mps: e.MPS,
            comments: this.comments[e.index],
            shipmentstatus:e.shipmentstatus,
            lastmodifiedby: this.userName,
          }
        });
        if(this.tempArr.length == 0){
          this.$alert("Please Select MPS Mark as Invalid On Child Level","","error");
        }else{
            this.isLoading = true
            let inputPayload = {}
            inputPayload.awb = this.awbnumber
            inputPayload.MPSArray = this.tempArr
            let result = await Utility.MarkMPSInvalid(inputPayload);
            if(result.data.code == 200){
              this.finalresult = result.data.data
              this.showMPSInvalid = true
              this.showMPSList =false
              this.isLoading = false
              this.Arr = []
            }else{
              this.$alertify.error(result.data.message);
              this.isLoading = false
            }
          }
        // }
      this.isLoading = false
      } catch (err) {
        console.log(err);
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.getMPSList();
    },
    closeShowMPSInvalid(){
      this.showMPSInvalid=false;
      this.finalresult=[]
      this.reset();
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/utility/views/Markshipmentinvalidonchild/Markshipmentinvalidonchild.component.js